"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductShelfLife = void 0;
/**
 * The shelf-life and storage information for a medicinal product item or container can be described using this class.
 */
var ProductShelfLife = /** @class */ (function () {
    function ProductShelfLife() {
    }
    return ProductShelfLife;
}());
exports.ProductShelfLife = ProductShelfLife;
